module.exports = __webpack_public_path__ + "img/superlever-bgNumer2.e87ade2b.svg";